import { gql } from '@apollo/client';

export default gql`
  query timetableServices($date: Date!, $originUic: String, $destinationUic: String, $trainNumber: String) {
    timetableServices(date: $date, trainNumber: $trainNumber, originUic: $originUic, destinationUic: $destinationUic) {
      model {
        trainNumber
        serviceName
        serviceStatus
        carrier
      }
      origin {
        station {
          ...stationModel
        }
      }
      destination {
        station {
          ...stationModel
        }
      }
      serviceStops {
        model {
          arrivalStatus
          actualArrivalDateTime
          actualDepartureDateTime
          commercialArrivalDateTime
          commercialDepartureDateTime
          departureStatus
          expectedArrivalDateTime
          expectedDepartureDateTime
          scheduledDepartureDateTime
          scheduledArrivalDateTime
          stopNumber
          platformNumber
        }
        station {
          ...stationModel
        }
      }
      news {
        model {
          id
          severity
          category
          title {
            ...translations
          }
          description {
            ...translations
          }
          commercial {
            ...translations
          }
          dateStart
          dateEnd
          dateEffectStart
          dateEffectEnd
          dateUpdate
        }
      }
    }
  }

  fragment stationModel on TimetableStationModel {
    uic
    shortCode
    name {
      ...translations
    }
  }

  fragment translations on TimetableTranslations {
    en
    fr
    de
    nl
  }
`;
